import * as authDashboard from 'api/dashboard'
import * as action from 'actions'
import {call, put, takeLatest, takeEvery, cancel} from 'redux-saga/effects'
import {change, initialize} from 'redux-form'
import {getFilteredDateAsMoment} from 'sagas/api/get-filtered-date'
import moment from 'moment'
import {setDashboard, setOutlets} from 'actions/dashboard'
import * as actActionBar from 'actions/actionBar'
import {getProfile} from 'sagas/api/profile'
import {loginOutlet} from 'sagas/api/login'
import * as apiOutlet from 'api/outlets'
import {
  GET_DASHBOARD_REQUEST,
  DASHBOARD_CHANGE_OUTLET,
  DASHBOARD_PAGE_REQUEST,
  DASHBOARD_CHANGE_DATE
} from 'actions/dashboard/constants'
import {
  LOGOUT
} from 'actions/constants'
import * as actNotification from 'actions/notifications'
import * as apiProfile from 'api/profile'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpDashboard from 'mixpanel/dashboard'

export function * pageRequest (request) {
  yield put(setDashboard({gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: []}))
  yield put(showPageLoadingSpinner(true))
  try {
    yield put(action.showProgressBar())
    const data = yield call(getFilteredDateAsMoment)
    const {startDate, endDate} = data

    const resOutlet = yield call(apiOutlet.outlets)
    yield put(setOutlets(resOutlet.data))
    yield put(actActionBar.setOutlets(resOutlet.data))

    const resProfile = yield call(apiProfile.getProfile)
    yield put(actActionBar.setSelectedOutletIds(resProfile.data.outlet_id))

    // init form value
    yield put(initialize('search', {
      'date': {startDate, endDate},
      'outlet': resProfile.data.outlet_id
    }))

    // call dashboard api
    const query = {
      start_date: startDate.format('D/M/YYYY'),
      end_date: endDate.format('D/M/YYYY')
    }
    const dashboardData = yield call(authDashboard.dashboard, query)
    yield put(setDashboard(dashboardData.data))
    mpDashboard.dashboardStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate
    })
  } catch (error) {
    yield put(actNotification.error(error.message))
  } finally {
    yield put(action.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * getDashboardRequestFlow (request) {
  yield put(showPageLoadingSpinner(true))
  let {payload} = request
  let {query} = payload
  if (!query) {
    // kalo gak ada startdate sama enddate, panggil api calendar untuk mengetahui current date
    let data = yield call(getFilteredDateAsMoment)
    let {startDate, endDate} = data
    yield put(change('search', 'date', {startDate, endDate}))
    query = {
      start_date: startDate.format('D/M/YYYY'),
      end_date: endDate.format('D/M/YYYY')
    }
  }

  yield put(action.sendingRequest(true))
  yield put(action.showProgressBar())
  const resOutlet = yield call(apiOutlet.outlets)
  yield put(setOutlets(resOutlet.data))
  try {
    const profileData = yield call(getProfile)
    yield put(change('search', 'outlet', profileData.outlet_id))
    // yield put(actOutlet.setCurrentOutlet(profileData))

    const dashboardData = yield call(authDashboard.dashboard, query)
    yield put(setDashboard(dashboardData.data))
  } catch (error) {
    yield put(actNotification.error(error.message))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * changeOutletFlow (request) {
  yield put(setDashboard({gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: []}))
  yield put(showPageLoadingSpinner(true))
  let {payload} = request
  let {outletIds, startDate, endDate} = payload

  yield call(loginOutlet, {id: outletIds})
  yield put(change('search', 'date', {startDate, endDate}))
  yield put(change('search', 'outlet', outletIds))
  yield put(actActionBar.setSelectedOutletIds(outletIds))
  const dashboardData = yield call(authDashboard.dashboard, {start_date: startDate.format('D/M/YYYY'), end_date: endDate.format('D/M/YYYY')})
  yield put(setDashboard(dashboardData.data))
  yield put(showPageLoadingSpinner(false))
}

export function * changeDateFlow (request) {
  yield put(setDashboard({gross_sales: 0, net_sales: 0, total_transactions: 0, top_items: [], transactions: []}))
  yield put(showPageLoadingSpinner(true))
  const {payload: {startDate, endDate}} = request

  const queryParams = {start_date: moment(startDate).format('D/M/YYYY'), end_date: moment(endDate).format('D/M/YYYY')}
  const dashboardData = yield call(authDashboard.dashboard, queryParams)
  yield put(setDashboard(dashboardData.data))
  yield put(showPageLoadingSpinner(false))
}

export function * cancelAction (args) {
  yield cancel(...args)
}

export default function * dashboardSaga () {
  const pageReqTask = yield takeLatest(DASHBOARD_PAGE_REQUEST, pageRequest)
  const task = yield takeLatest(GET_DASHBOARD_REQUEST, getDashboardRequestFlow)
  const task2 = yield takeLatest(DASHBOARD_CHANGE_OUTLET, changeOutletFlow)
  const changeDateTask = yield takeLatest(DASHBOARD_CHANGE_DATE, changeDateFlow)

  yield takeEvery(LOGOUT, cancelAction, [task, task2, pageReqTask, changeDateTask])
}



// WEBPACK FOOTER //
// ./app/sagas/dashboard/index.js